import React from 'react';
import Route from './App/Route';
import Header from './App/Containers/Header';
import { AppContextProvider } from './App/App.context';


class App extends React.Component {
  state = { patients: [] };
  constructor() {
    super();
    this.state = {
      isAuthenticated: true
    };
  }


  render() {
    const childProps = {
      // isAuthenticated: this.state.isAuthenticated,
      // userHasAuthenticated: this.userHasAuthenticated,
      // handleLogout:this.handleLogout
    };
    return (
      <AppContextProvider>
        <Header childProps={childProps} />
        <div className="App">
          <Route childProps={childProps} />
        </div>
      </AppContextProvider>
    );
  }
}

export default App;
